"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    convertToErrorString: function() {
        return convertToErrorString;
    },
    errorMessage: function() {
        return errorMessage;
    }
});
const _errorMessage = require("../../../elements-sk/modules/errorMessage");
const _telemetry = require("../telemetry/telemetry");
const convertToErrorString = (errorBody)=>{
    if (typeof errorBody === 'string') {
        return errorBody;
    }
    if (typeof errorBody === 'object' && errorBody !== null) {
        if ('message' in errorBody) {
            return errorBody.message;
        }
        if ('resp' in errorBody && errorBody.resp instanceof window.Response) {
            return errorBody.resp.statusText;
        }
    }
    try {
        return JSON.stringify(errorBody);
    } catch (e) {
        return `Failed to report log message from frontend: ${e.message}`;
    }
};
const errorMessage = (message, duration = 0, options)=>{
    if (options) {
        const source = options.source || 'default';
        const errorCode = options.errorCode || (isMessageWithResponse(message) ? message.resp.status.toString() : '500');
        // 1. Log the full high-cardinality metadata to the backend
        _telemetry.telemetry.reportErrorToServer(convertToErrorString(message), options);
        // 2. Increment the time-series metric counter with safe tags
        const metricName = options.countMetricSource || _telemetry.CountMetric.FrontendErrorReported;
        _telemetry.telemetry.increaseCounter(metricName, {
            source: source,
            errorCode: errorCode
        });
    }
    // 3. Display the UI toast
    (0, _errorMessage.errorMessage)(message, duration);
};
/**
 * Type guard to check if an unknown object contains a valid Fetch API Response.
 */ function isMessageWithResponse(msg) {
    return typeof msg === 'object' && msg !== null && 'resp' in msg && msg.resp instanceof Response;
}
